import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  MODULE_FILE_CSV_UPLOAD,
  MODULE_AVAILABLE_MODULE_FIELDS,
  FILE_ATTACHMENT_CREATE_PREAUTH,
} from "./actionType";
import {
  moduleFileCsvUploadSuccess,
  moduleFileCsvUploadError,
  moduleAvailableModuleFieldsSuccess,
  moduleAvailableModuleFieldsError,
  fileAttachmentCreatePreauthSuccess,
  fileAttachmentCreatePreauthError,
} from "./action";

import {
  moduleFileCsvUploadApi,
  moduleAvailableModuleFieldsApi,
  fileAttachmentCreatePreauthApi,
} from "../../helpers/fakebackend_helper";

//MODULE_FILE_CSV_UPLOAD
export function* moduleFileCsvUploadSaga(action) {
  try {
    const response = yield call(moduleFileCsvUploadApi, action.payload);
    yield put(moduleFileCsvUploadSuccess(response));
  } catch (error) {
    yield put(moduleFileCsvUploadError(error));
  }
}

export function* watchModuleFileCsvUploadSaga() {
  yield takeEvery(MODULE_FILE_CSV_UPLOAD, moduleFileCsvUploadSaga);
}

//MODULE_AVAILABLE_MODULE_FIELDS
export function* moduleAvailableModuleFieldsSaga() {
  try {
    const response = yield call(moduleAvailableModuleFieldsApi);
    yield put(moduleAvailableModuleFieldsSuccess(response));
  } catch (error) {
    yield put(moduleAvailableModuleFieldsError(error));
  }
}

export function* watchModuleAvailableModuleFieldsSaga() {
  yield takeEvery(
    MODULE_AVAILABLE_MODULE_FIELDS,
    moduleAvailableModuleFieldsSaga
  );
}

//FILE_ATTACHMENT_CREATE_PREAUTH
export function* fileAttachmentCreatePreauthSaga(action) {
  try {
    const response = yield call(fileAttachmentCreatePreauthApi, action.payload);
    yield put(fileAttachmentCreatePreauthSuccess(response));
  } catch (error) {
    yield put(fileAttachmentCreatePreauthError(error));
  }
}

export function* watchFileAttachmentCreatePreauthSaga() {
  yield takeEvery(
    FILE_ATTACHMENT_CREATE_PREAUTH,
    fileAttachmentCreatePreauthSaga
  );
}

//default saga
export default function* FileUploads() {
  yield all([
    fork(watchModuleFileCsvUploadSaga),
    fork(watchModuleAvailableModuleFieldsSaga),
    fork(watchFileAttachmentCreatePreauthSaga),
  ]);
}
